<h2 mat-dialog-title class="text-center">
  {{info?.title}}
  <button class="close-btn" mat-dialog-close mat-icon-button>
    <i class="material-icons">close</i>
  </button>
</h2>
<mat-dialog-content>
  <img loading="lazy" class="img-fluid" data-src="/assets/images/medical-fr/sample-fr-image-1.jpg" alt="Sample fundraiser images">
  <div class="image-text text-center mb-3 mt-1">Image of child with parent</div>
  <img loading="lazy" class="img-fluid" data-src="/assets/images/medical-fr/sample-fr-image-2.jpg" alt="Sample fundraiser images">
  <div class="image-text text-center mb-3 mt-1">Image with patient looking into the camera</div>
  <img loading="lazy" class="img-fluid" data-src="/assets/images/medical-fr/sample-fr-image-3.jpg" alt="Sample fundraiser images">
  <div class="image-text text-center mb-3 mt-1">Image of patient when healthy</div>
  <img loading="lazy" class="img-fluid" data-src="/assets/images/medical-fr/sample-fr-image-4.jpg" alt="Sample fundraiser images">
  <div class="image-text text-center mb-3 mt-1">Image of patient with ailment visible</div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-center">
  <app-button type="button" [label]="info?.got_it" btnClass=" width-100" (click)="closePopup()"></app-button>
</div>
